import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PreavisConsultModal = _resolveComponent("PreavisConsultModal")!
  const _component_PreavisCreateModal = _resolveComponent("PreavisCreateModal")!
  const _component_PreavisConfirmationCreatedModal = _resolveComponent("PreavisConfirmationCreatedModal")!
  const _component_PreavisDeleteModal = _resolveComponent("PreavisDeleteModal")!
  const _component_PreavisFormCreateEdit = _resolveComponent("PreavisFormCreateEdit")!
  const _component_ModalCardConfirm = _resolveComponent("ModalCardConfirm")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_WaitingModal = _resolveComponent("WaitingModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_PreavisConsultModal, {
      ref: "consultRef",
      contentMaxHeight: '75vh',
      maxWidth: '80%',
      title: _ctx.$t('modale.preavisIntervention.title'),
      visible: true,
      width: '75vw',
      onCancel: _ctx.cancel,
      onDelete: _ctx.onDelete,
      onEdit: _ctx.onEdit,
      onToggleActif: _ctx.onToggleActif,
      onOpenCreate: _ctx.openCreate
    }, null, 8, ["title", "onCancel", "onDelete", "onEdit", "onToggleActif", "onOpenCreate"]),
    _createVNode(_component_PreavisCreateModal, {
      initialStep: _ctx.createDirectPayload ? _ctx.createDirectPayload.initialStep : 1,
      preselectedEquipement: _ctx.createDirectPayload ? _ctx.createDirectPayload.equipement : null,
      preselectedSiteId: _ctx.createDirectPayload && _ctx.createDirectPayload.equipement ? _ctx.createDirectPayload.equipement.adresseProjetId : null,
      title: _ctx.$t('modale.preavisIntervention.create.title'),
      visible: _ctx.showCreateModal,
      onCancel: _ctx.closeCreateModal,
      onCreated: _ctx.onCreateSuccess
    }, null, 8, ["initialStep", "preselectedEquipement", "preselectedSiteId", "title", "visible", "onCancel", "onCreated"]),
    _createVNode(_component_PreavisConfirmationCreatedModal, {
      hideNouveauPreavis: !!_ctx.createDirectPayload,
      visible: _ctx.showCreatedModal,
      onClose: _ctx.closeAllPreavisModals,
      onMesPreavis: _ctx.onMesPreavis,
      onNouveauPreavis: _ctx.onNouveauPreavis
    }, null, 8, ["hideNouveauPreavis", "visible", "onClose", "onMesPreavis", "onNouveauPreavis"]),
    _createVNode(_component_PreavisDeleteModal, {
      message: _ctx.$t('preavisIntervention.modale.delete.message', { objet: _ctx.alertPendingDelete?.objet }),
      title: _ctx.$t('preavisIntervention.modale.delete.title'),
      visible: _ctx.showDeleteModal,
      onCancel: _ctx.closeDeleteModal,
      onConfirm: _ctx.deleteDemande
    }, null, 8, ["message", "title", "visible", "onCancel", "onConfirm"]),
    (_ctx.showForm)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 0,
          onCancel: _ctx.closeForm
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ModalCardConfirm, {
              activeValidate: _ctx.editFormValid && !_ctx.isSubmitting,
              "content-max-height": '75vh',
              headerTitle: _ctx.$t('modale.preavisIntervention.edit.title'),
              "max-width": '80%',
              overflowContent: 'visible',
              width: '40vw',
              onCancel: _ctx.closeForm,
              onConfirm: _ctx.onSubmit
            }, {
              default: _withCtx(() => [
                _createVNode(_component_PreavisFormCreateEdit, {
                  ref: "editFormulaireRef",
                  initialDelai: _ctx.form.delai || 1,
                  initialEmails: _ctx.form.emails,
                  initialObjet: _ctx.form.objet,
                  mode: "edit",
                  onStateChange: _ctx.onEditStateChange
                }, null, 8, ["initialDelai", "initialEmails", "initialObjet", "onStateChange"])
              ]),
              _: 1
            }, 8, ["activeValidate", "headerTitle", "onCancel", "onConfirm"])
          ]),
          _: 1
        }, 8, ["onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.isSubmitting)
      ? (_openBlock(), _createBlock(_component_WaitingModal, { key: 1 }))
      : _createCommentVNode("", true)
  ], 64))
}